
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  getDeviceList,
  setChangeStatus,
  getVerifyCode,
  setTrustDevice,
} from '@/api/accessDevice/accessDevice'
import { delObjEmptyKey } from '@/utils'
import { AppModule } from '@/store/modules/app'
import { Form as ElForm } from 'element-ui'

@Component({
  name: 'accessDevice',
  components: {},
})
export default class extends Vue {
  private queryForm: any = {
    username: '',
    os: '',
    browser: '',
    family: '',
    brand: '',
    ip: '',
  }
  private rules: any = {
    code: [
      { required: true, message: 'Please enter email code', trigger: 'blur' },
    ],
    google_code: [
      { required: true, message: 'Please enter google code', trigger: 'blur' },
    ],
  }
  private listLoading: boolean = false
  private list: any[] = []
  private total = 0

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }

  private reset() {
    this.queryForm = {
      username: '',
      os: '',
      browser: '',
      family: '',
      brand: '',
      ip: '',
    }
    this.hadleGetFilesListApi()
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }
  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }
  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      if (this.timer.length > 0) {
        this.clearTime()
      }
      this.listLoading = true
      const data = {
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage,
      }
      delObjEmptyKey(data)
      await getDeviceList(data).then((res: any) => {
        this.total = res.count
        this.list = res.results
        this.list.map((item: any) => {
          item.messageCodeVis = false
        })
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 设备状态更改
  private async setStatus(row: any) {
    try {
      const data: any = {
        device_id: row.device_id,
        status: row.status,
      }
      await setChangeStatus(data).then(() => {
        this.$message({
          message: 'Change successful!',
          type: 'success',
        })
      })
    } catch (error) {}
  }

  private deviceInfo: any = {}
  private deviceIndex: any = null
  private botDialogVisible: boolean = false
  private openDialogVisible(index: any, row: any) {
    this.deviceInfo = row
    this.deviceIndex = index
    this.botDialogVisible = true
  }

  private deviceForm: any = {
    code: '',
    google_code: '',
  }
  private loadingBtn: boolean = false
  private sendCode() {
    this.loadingBtn = true
    this.getEmailCode()
  }
  /* 倒计时函数 */
  private timer: any = []
  private startCountdown() {
    this.list.map((item, index) => {
      if (item.messageCodeVis) {
        let intervalId = setInterval(() => {
          if (item.countdown > 0) {
            item.countdown = item.countdown - 1
          } else {
            clearInterval(intervalId)
            item.messageCodeVis = false
          }
          this.$forceUpdate()
        }, 1000)
        this.timer.push(intervalId)
      }
    })
  }
  // 获取邮箱验证码
  private async getEmailCode() {
    try {
      this.clearTime()
      await getVerifyCode(this.deviceInfo.device_id)
        .then((res) => {
          this.$message({
            message: 'The verification code has been sent!',
            type: 'success',
          })
          this.deviceInfo.messageCodeVis = true
          this.deviceInfo.countdown = 60
          this.loadingBtn = false
          this.$set(this.list, this.deviceIndex, this.deviceInfo)
          this.startCountdown()
          this.$forceUpdate()
        })
        .catch((err) => {
          this.loadingBtn = false
          this.deviceInfo.messageCodeVis = true
          this.deviceInfo.countdown = err.response.data.seconds
          this.$set(this.list, this.deviceIndex, this.deviceInfo)
          this.startCountdown()
          this.$forceUpdate()
        })
    } catch (error) {
      this.loadingBtn = false
    }
  }
  private closeSaleVisible() {
    this.botDialogVisible = false
    this.deviceForm = {
      code: '',
      google_code: '',
    }
  }
  private saleBtn: boolean = false
  private changeSales() {
    ;(this.$refs.deviceForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.saleBtn = true
          let data = {
            device_id: this.deviceInfo.device_id,
            ...this.deviceForm,
          }
          await setTrustDevice(data).then((res: any) => {
            this.$message.success('Successful operation!')
            this.saleBtn = false
            this.closeSaleVisible()
          })
        } catch (error) {
          this.saleBtn = false
        }
      }
    })
  }

  clearTime() {
    this.timer.forEach((element) => {
      window.clearInterval(element)
    })
    this.timer = []
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.hadleGetFilesListApi()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.accessDevice`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
  destroyed() {
    this.timer.forEach((element) => {
      window.clearInterval(element)
    })
    this.timer = []
  }
}
